import gql from 'graphql-tag'

export const productsQuery = gql`
  query products ($date: Date!, $categoryId: ID, $tagIds: [ID]) {
    products (orderDate: $date, categoryId: $categoryId, tagIds: $tagIds) {
      data {
        id
        name
        slug
        item_number
        unit
        best_before
        bioland
        weekend_product
        weekday_availability_readable
        image_path
        attachment_path
        orderable
        orderable_from
        orderable_to
        primary_category {
          id
          atypical_quantity
        }
      }
    }
  }
`

export const orderQuery = gql`
  query order ($date: Date!) {
    order(orderDate: $date) {
      id
      date
      submitted
      submitted_at
      editable
      products {
        id
        name
        slug
        item_number
        pivot {
          quantity
        }
      }
    }
  }
`
